import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiSitesBuilderService {
  private readonly http: HttpClient = inject(HttpClient);

  public getRedirectUrl$(title: string) {
    return this.http
      .get<{ redirectUrl: string | null }>(`${environment.apiSiteUrl}/api/sites/redirect/${title}`)
      .pipe(map(res => res?.redirectUrl ?? null));
  }

}
